import mutations from './medicationSelect.mutations'
import actions from './medicationSelect.actions'
import getters from './medicationSelect.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
